import { Box, Modal } from "@mui/material";
import React from "react";
import Close from "../../Components/Icons/Close";
import { makeStyles } from "@mui/styles";
import cssClasses from "./AllotmentPayment.module.css";
import { useEffect } from "react";
import CustomInput from "../../Subcomponents/CustomInput";
import { useState } from "react";
import Button from "../../Subcomponents/Button";
import RupeeIcon from "../../Assets/Images/Sustenance/RupeeIcon.svg";
import { numberWithCommas } from "../../Assets/Common/CommonFunctions";

const useStyles = makeStyles((theme) => ({
	tokenName: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "2rem",
		lineHeight: "3rem",
		color: "#000000",
	},
	wrapperIcons: {
		display: "flex",
		flexDirection: "row",
		alignItems: "flex-start",
		justifyContent: "space-around",
		marginBottom: "2rem",
		position: "relative",
	},
	closeIcon: {
		cursor: "pointer",
		position: "absolute",
		right: "1.7rem",
		top: "1.7rem",
	},
	title: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.8rem",
		lineHeight: "2.8rem",
		color: "#101828",
		marginBottom: "0.8rem",
	},
	subTitle: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.4rem",
		lineHeight: "2rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	labelCard: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.4rem",
		lineHeight: "2rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	labelValue: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.4rem",
		lineHeight: "2rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	wrapperButtons: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		columnGap: "1.2rem",
	},
	backArrow: {
		verticalAlign: "middle",
	},
}));

const AllotmentPayment = ({ open, handleClose, allotmentDetails, allotmentPaymentResponse, pendingTransaction }) => {
	const [payableAmount, setPayableAmount] = useState(0);
	const [enableBtn, setEnableBtn] = useState(false);
	const classes = useStyles();
	useEffect(() => {
		let amt =
			allotmentDetails?.bookingAmt?.total - allotmentDetails.paidAmount > 500000
				? 500000
				: allotmentDetails?.bookingAmt?.total - allotmentDetails.paidAmount;
		setPayableAmount(amt);
		setEnableBtn(true);
	}, []);
	function closeModal() {
		handleClose();
	}

	const [helperText, setHelperText] = useState("");
	return (
		<Modal
			open={open}
			onClose={(_, reason) => {
				if (reason !== "backdropClick") {
					handleClose();
				}
			}}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
			sx={[
				{
					".MuiBackdrop-root": {
						background: "rgba(52, 64, 84, 0.7)",
					},
				},
			]}
			disableAutoFocus={true}
		>
			<Box className={cssClasses.modalWrapper}>
				<div className={cssClasses.wrapperHeader}>
					<span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
						<Close width={"1.2rem"} height={"1.2rem"} />
					</span>
					<div>Allotment Payment</div>
				</div>
				<div className={cssClasses.wrapperContent}>
					<div className={cssClasses.cardHeader}>
						<div className={cssClasses.tokenNumWrap}>
							<span>
								{allotmentDetails.unitId?.wingId?.displayName
									? allotmentDetails.unitId?.wingId?.displayName
									: allotmentDetails.unitId?.wingId?.wingName}{" "}
								- {allotmentDetails.unitId?.unitNo}{" "}
							</span>
							<span>|</span>
							<span>{allotmentDetails.unitId?.projectId?.projectName}</span>
						</div>
					</div>
					<div className={cssClasses.cardDetails}>
						<div className={cssClasses.tokenDetails}>
							<div className={cssClasses.tokenData}>
								{allotmentDetails.paymentId && (
									<>
										<span>{allotmentDetails.paymentId?.eventTokenId?.eventId?.title}</span>
										<span>|</span>
									</>
								)}
								<span>{allotmentDetails.unitId?.inventoryTypeId.type}</span>
								<span>|</span>
								<span>{allotmentDetails.unitId?.floorNo}</span>
								<span>|</span>
								{allotmentDetails.paymentId && (
									<>
										<span>{allotmentDetails.paymentId?.tokenNumber}</span>
										<span>|</span>
										<span>{allotmentDetails.paymentId?.eventTokenId.tokenId.name}</span>
									</>
								)}
							</div>
							<div className={cssClasses.tokenData}>
								<span>Alloted On: </span>
								<span>
									{new Date(allotmentDetails.created_at).toDateString()},{" "}
									{new Date(allotmentDetails.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
								</span>
							</div>
						</div>
					</div>
					<div className={cssClasses.priceBreakDown}>
						{/* <div className={cssClasses.price}>
                            <span>OCR : </span>
                            <span>₹ {numberWithCommas(allotmentDetails.OCR)}</span>
                        </div> */}
						<div className={cssClasses.price}>
							<span>Booking Amount : </span>
							<span>₹ {allotmentDetails?.bookingAmt?.total}</span>
						</div>
						<div className={cssClasses.paidAmt}>
							<span>Paid Amount: </span>
							<span>₹ {numberWithCommas(allotmentDetails.paidAmount)}</span>
						</div>
						<div className={cssClasses.price}>
							<span>Amount Due : </span>
							<span>₹ {numberWithCommas(allotmentDetails?.bookingAmt?.total - allotmentDetails.paidAmount)}</span>
						</div>
					</div>
					<div className={cssClasses.amountInputWrap}>
						<CustomInput
							className={cssClasses.customInput}
							value={payableAmount}
							label={"Enter amount"}
							mandatory={true}
							inputType={"number"}
							position="start"
							labelText={RupeeIcon}
							image={"true"}
							handleChange={(amt) => {
								setEnableBtn(false);
								amt = amt === "" ? "0" : amt;
								var numbers = /^[0-9]+$/;
								setPayableAmount(parseInt(amt));
								if (amt.match(numbers) && parseInt(amt) >= 0 && parseInt(amt) <= allotmentDetails?.bookingAmt?.total) {
									if (parseInt(amt) > 0 && parseInt(amt) <= 500000) {
										if (parseInt(amt) <= allotmentDetails?.bookingAmt?.total - allotmentDetails.paidAmount) {
											setEnableBtn(true);
										}
									} else {
										setEnableBtn(false);
									}
								} else {
									setEnableBtn(false);
								}
								if (parseInt(amt) > 500000 && allotmentDetails?.bookingAmt?.total - allotmentDetails.paidAmount > 500000) {
									setHelperText("Payable Amount limit is 500000");
								} else if (parseInt(amt) > allotmentDetails?.bookingAmt?.total - allotmentDetails.paidAmount) {
									setHelperText(
										`Max. amount to be paid: ₹ ${numberWithCommas(
											allotmentDetails?.bookingAmt?.total - allotmentDetails.paidAmount
										)}`
									);
								} else {
									setHelperText("");
								}
							}}
							helperText={helperText}
						/>
						<p style={{ fontStyle: "italic", color: "#667085", textAlign: "left", whiteSpace: "nowrap" }}>
							Max. amount to be paid: ₹{" "}
							{numberWithCommas(
								allotmentDetails?.bookingAmt?.total - allotmentDetails?.paidAmount > 500000
									? 500000
									: allotmentDetails?.bookingAmt?.total - allotmentDetails?.paidAmount
							)}
						</p>
					</div>
					{/* } */}
				</div>
				<div className={cssClasses.wrapperFooter}>
					<div>
						<Button
							style={{
								color: "#344054",
								backgroundColor: "#ffffff",
								fontSize: "1.6rem",
								lineHeight: "2.4rem",
							}}
							btnName={"Cancel"}
							clicked={() => {
								closeModal();
							}}
						/>
					</div>
					<div>
						<Button
							style={{
								color: "#ffffff",
								backgroundColor: "#155EEF",
								fontSize: "1.6rem",
								lineHeight: "2.4rem",
							}}
							disable={!enableBtn}
							btnName={"Pay Now"}
							clicked={() => {
								// if (pendingTransaction.length > 0) {
								//     presentLoader()
								//     axios.post(`${process.env.REACT_APP_PAYMENT_LINK_URL}payments/get-payment-link`, { linkId: pendingTransaction[0].paymentLinkId }).then((resp) => {
								//         console.log(resp.data.link)
								//         dismissLoader()
								//         handleClose()
								//         setPendingTransaction([])
								//         setAllotmentDetails({})
								//         window.open(resp.data.link, '_blank')
								//     })
								// } else {
								// allotmentPaymentResponse(payableAmount);
								// }
								allotmentPaymentResponse(payableAmount);
							}}
							//   disable={disabeNext}
						/>
					</div>
				</div>
			</Box>
		</Modal>
	);
};

export default AllotmentPayment;
